import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Database, CheckCircle2 } from 'lucide-react';

interface DataSourcesCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function DataSourcesCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: DataSourcesCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Data Sources
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2 rounded bg-green-50 border border-green-200">
              <div className="flex items-center gap-2">
                <Database className="h-4 w-4 text-green-600" />
                <span className="text-sm">Xero</span>
              </div>
              <Badge className="bg-green-600 text-[10px]">
                <CheckCircle2 className="h-2 w-2 mr-1" />
                Connected
              </Badge>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-green-50 border border-green-200">
              <div className="flex items-center gap-2">
                <Database className="h-4 w-4 text-green-600" />
                <span className="text-sm">QuickBooks</span>
              </div>
              <Badge className="bg-green-600 text-[10px]">
                <CheckCircle2 className="h-2 w-2 mr-1" />
                Connected
              </Badge>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <Database className="h-4 w-4 text-muted-foreground" />
                <span className="text-sm">Sage</span>
              </div>
              <Badge variant="outline" className="text-[10px]">Not connected</Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
